import { useContext } from 'react';

import { TagFormContext } from './tag-form-context';

export const useOpenEditTagDialog = () => {
  const { onEditTag } = useContext(TagFormContext);

  return onEditTag;
};
